import styled from '@emotion/styled';

export const Right = styled.div`
  display: flex;
  flex-direction: row;
`;
